import DocumentCard from './DocumentCard'
export default DocumentCard